import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import {
  DateString,
  OrderChangesHistory,
  OrderDetailsType,
  OrderWithPagination
} from './types.ts'

const getOrders = async (params = '') => {
  try {
    const response = await httpClient.get<OrderWithPagination>(
      `api/dd_panel_orders/${params}`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const getOrder = async (orderId: number) => {
  try {
    const response = await httpClient.get<OrderDetailsType>(
      `api/dd_panel_orders/${orderId}`
    )
    return response.data
  } catch {
    return null
  }
}

const postRealizeOrder = async (
  orderId: number,
  dietBaseFolderId: number | null,
  selectedDietID: number | null,
  plannedShareDate: DateString
) => {
  try {
    const response = await httpClient.post(
      `api/dd_panel_orders/${orderId}/realize/`,
      {
        diet_base_folder: dietBaseFolderId,
        diet_base_diet: selectedDietID,
        planned_share_date: plannedShareDate
      }
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      console.error('postRealizeOrder Error : ', error.response)
    }
    throw new Error('An unexpected error occurred')
  }
}

const getOrderChangesHistory = async (orderId: number) => {
  try {
    const response = await httpClient.get<OrderChangesHistory[]>(
      `api/dd_panel_orders/${orderId}/history/`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}
// survey_answers
const getSurveyAnswers = async () => {
  try {
    const response = await httpClient.get('/api/orders/survey_answers')
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
    }
    throw new Error('An unexpected error occurred')
  }
}

const postToggleSaleDocument = async (orderId: number) => {
  try {
    const response = await httpClient.post(
      `/api/dd_panel_orders/${orderId}/toggle_sale_document_created/`
    )
    return response.data
  } catch (error) {
    if (isAxiosError(error)) {
      console.error('postToggleSaleDocument Error : ', error.response)
    }
    throw new Error('An unexpected error occurred')
  }
}

export const orders = {
  getOrders,
  getOrder,
  postRealizeOrder,
  getOrderChangesHistory,
  getSurveyAnswers,
  postToggleSaleDocument,
}
